import { tryAxios } from '@/api/common/auth'
import { urlPrefix } from '@/configs/api'

const apiUrl = `${urlPrefix}/VideoPlay`
//#region 数据源相关api
/** 有监控点的文保单位集合 */
const GetUnitList = `${apiUrl}/units`
const GetUnitVideos = (id: number, onlineStatus: number) => `${apiUrl}/unit/videos/${id}_${onlineStatus}`

/** 视频分组 */
const GetGroupList = `${apiUrl}/groups`
const GetGroup = (id: number) => `${apiUrl}/group/${id}`
const PostGroup = `${apiUrl}/group`
const PutGroup = (id: number) => `${apiUrl}/group/${id}`
const DeleteGroup = (id: number) => `${apiUrl}/group/${id}`

/** 视频轮播 */
const GetRotationList = `${apiUrl}/rotations`
const GetRotationGroups = (id: number) => `${apiUrl}/rotation/groups/${id}`
const GetRotationVideos = (id: number) => `${apiUrl}/rotation/videos/${id}`
const GetRotation = (id: number) => `${apiUrl}/rotation/${id}`
const PostRotation = `${apiUrl}/rotation`
const PutRotation = (id: number) => `${apiUrl}/rotation/${id}`
const DeleteRotation = (id: number) => `${apiUrl}/rotation/${id}`

/** 分组下的视频，轮播组中的子分组也是调用这个 */
const GetGroupVideos = (id: number) => `${apiUrl}/group/videos/${id}`
//#endregion

export class VideoRotationData {
    [key: string]: any
    Id: number
    RotationName: string
    VideoNumber: number
    PlayDuration: number
    GroupList: VideoGroupData[]
    constructor() {
        this.Id = 0
        this.RotationName = ''
        this.VideoNumber = 0
        this.PlayDuration = 0
        this.GroupList = []
    }
}
export class VideoGroupData {
    [key: string]: any
    Id: number
    GroupName: string
    GroupType: number
    Sequence: number
    PointList: VideoGroupPointData[]
    constructor() {
        this.Id = 0
        this.GroupName = ''
        this.GroupType = 0
        this.Sequence = 0
        this.PointList = []
    }
}
export class VideoGroupPointData {
    [key: string]: any
    Id: number
    GroupId: number
    GroupName: string
    GroupSeq: number
    VideoPointId: number
    Sequence: number
    PointNumber: string
    PointName: string
    StreamMode: number
    Online: number
    constructor() {
        this.Id = 0
        this.GroupId = 0
        this.GroupName = ''
        this.GroupSeq = 0
        this.VideoPointId = 0
        this.Sequence = 0
        this.PointNumber = ''
        this.PointName = ''
        this.StreamMode = 0
        this.Online = 0
    }
}

//#region 分组维护
export const getGroupInfo = (id: number) => {
    return tryAxios({
        method: 'get',
        url: GetGroup(id)
    })
}
export const postGroup = (form: any) => {
    return tryAxios({
        method: 'post',
        url: PostGroup,
        data: form
    })
}
export const putGroup = (id: number, form: any) => {
    return tryAxios({
        method: 'put',
        url: PutGroup(id),
        data: form
    })
}
export const removeGroup = (id: number) => {
    return tryAxios({
        method: 'delete',
        url: DeleteGroup(id)
    })
}
//#endregion

//#region 轮播组维护
export const getRotationInfo = (id: number) => {
    return tryAxios({
        method: 'get',
        url: GetRotation(id)
    })
}
export const postRotation = (form: any) => {
    return tryAxios({
        method: 'post',
        url: PostRotation,
        data: form
    })
}
export const putRotation = (id: number, form: any) => {
    return tryAxios({
        method: 'put',
        url: PutRotation(id),
        data: form
    })
}
export const removeRotation = (id: number) => {
    return tryAxios({
        method: 'delete',
        url: DeleteRotation(id)
    })
}
//#endregion
export const getUnitList = (param: any) => {
    return tryAxios({
        method: 'get',
        url: GetUnitList,
        params: param
    })
}
export const getUnitVideos = (id: number, onlineStatus: number) => {
    return tryAxios({
        method: 'get',
        url: GetUnitVideos(id, onlineStatus)
    })
}
export const getGroupList = (param: any) => {
    return tryAxios({
        method: 'get',
        url: GetGroupList,
        params: param
    })
}
export const getGroupVideos = (id: number) => {
    return tryAxios({
        method: 'get',
        url: GetGroupVideos(id)
    })
}
export const getRotationList = (param: any) => {
    return tryAxios({
        method: 'get',
        url: GetRotationList,
        params: param
    })
}
export const getRotationGroups = (id: number) => {
    return tryAxios({
        method: 'get',
        url: GetRotationGroups(id)
    })
}
export const getRotationVideos = (id: number) => {
    return tryAxios({
        method: 'get',
        url: GetRotationVideos(id)
    })
}